export default "__VITE_ASSET__B3VMdoWU__"